import { render } from "./FormOrdine.vue?vue&type=template&id=37bdd0cb&scoped=true"
import script from "./FormOrdine.vue?vue&type=script&lang=js"
export * from "./FormOrdine.vue?vue&type=script&lang=js"

import "./FormOrdine.vue?vue&type=style&index=0&id=37bdd0cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bdd0cb"]])

export default __exports__